var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mapsMode && _vm.selectedRelease
    ? _c(
        "div",
        {
          staticClass:
            "d-flex flex-column justify-content-center align-items-center",
          staticStyle: { gap: "5px" },
        },
        [
          _c("Generic_LatLong", {
            attrs: {
              map: _vm.map,
              mapsMode: _vm.mapsMode,
              clickedCoords: _vm.clickedCoords,
            },
            on: {
              addPoint: function ($event) {
                return _vm.$emit("addPoint", $event)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }